/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchDatasetPathParams = NonNullable<operations['patchDataset']['parameters']['path']>;

export type PatchDatasetRequestBody = OperationRequestBodyContent<operations['patchDataset']>;

export interface Input extends PatchDatasetPathParams {
  apiVersion?: string;
  body: PatchDatasetRequestBody;
}

export async function patchDataset(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/internal/projects/{projKey}/datasets/{datasetId}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
